export default __webpack_public_path__ + "static/media/55t.561b29ef.jpg";